import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconArrowRight } from "../Icons";
import GlitchText from "../GlitchText";
import WaveDivider from "./WaveDivider";

type SectionTitleProps = {
	id?: string;
	kicker: string;
	title: string;
	titleId?: string;
	action?: { to: string; label: string };
	children?: ReactNode;
};

export default function SectionTitle({
	id,
	kicker,
	title,
	titleId,
	action,
}: SectionTitleProps) {
	return (
		<div id={id} className="home-section-title-block">
			<WaveDivider />
			<div className="home-section-title">
				<GlitchText
					key={title}
					text={title}
					as="h2"
					id={titleId}
					className="home-section-title-text"
					stageClassName="home-section-title-stage"
					ariaLabel={title}
				/>
				<div className="home-section-title-meta">
					<span className="home-section-kicker">{kicker}</span>
					{action ? (
						<Link to={action.to}>
							{action.label} <IconArrowRight width="16" height="16" />
						</Link>
					) : null}
				</div>
			</div>
			<WaveDivider />
		</div>
	);
}
